import clsx from 'clsx';
import { useUiStore } from '../stores/ui';

const KIND_STYLES: Record<string, string> = {
  info: 'border-[var(--border-strong)] bg-[var(--bg-elevated)]',
  success: 'border-[var(--success)] bg-[var(--success-bg)] text-[var(--success)]',
  error: 'border-[var(--danger)] bg-[var(--danger-bg)] text-[var(--danger)]',
};

export function ToastStack() {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismissToast);

  return (
    <div aria-live="polite" className="fixed bottom-3 right-3 z-[100] flex w-80 flex-col gap-1.5">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={clsx('flex items-start justify-between gap-2 rounded-[3px] border px-2.5 py-2 text-[12.5px] shadow-none', KIND_STYLES[t.kind])}
        >
          <span className="leading-snug">{t.message}</span>
          <button
            onClick={() => dismiss(t.id)}
            className="shrink-0 text-[var(--text-faint)] hover:text-[var(--text)]"
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
